import type { AcademicTerm } from '../types/domain';
import { resolveTermNumberForViewDate } from './dashboardLessonSectionResolve';
import { buildWeeksFromRange } from './programProgressRows';

/**
 * viewDate가 속한 학기의 주차(1…N). 연간시간표 주 열과 동일하게 `buildWeeksFromRange` 사용.
 * terms는 연간진도 meta 캐시에서 온 값만 사용 (추가 DB 조회 없음).
 */
export function resolveSemesterWeekIndex(
  terms: AcademicTerm[],
  mondayIso: string,
  dateIso: string
): number | null {
  if (!terms.length || !mondayIso.trim() || !dateIso.trim()) return null;
  const termNumber = resolveTermNumberForViewDate(terms, dateIso);
  const term = terms.find((t) => t.term_number === termNumber);
  if (!term?.starts_on || !term?.ends_on) return null;
  const weeks = buildWeeksFromRange(term.starts_on, term.ends_on);
  const hit = weeks.find((w) => w.mondayIso === mondayIso);
  return hit ? hit.weekIndex : null;
}

export const DASHBOARD_WEEKDAY_EN = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'] as const;

/** mondayIso(월) 기준 일~일 ISO (월=0 … 일=6) */
export function weekDateIsosFromMonday(mondayIso: string): string[] {
  const base = new Date(`${mondayIso}T00:00:00`);
  if (Number.isNaN(base.getTime())) return [];
  const out: string[] = [];
  for (let i = 0; i < 7; i += 1) {
    const d = new Date(base);
    d.setDate(base.getDate() + i);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    out.push(`${y}-${m}-${day}`);
  }
  return out;
}

export function formatDashboardWeekMmDd(iso: string): string {
  const m = Number(String(iso).slice(5, 7));
  const d = Number(String(iso).slice(8, 10));
  if (!Number.isFinite(m) || !Number.isFinite(d)) return '--.--';
  return `${String(m).padStart(2, '0')}.${String(d).padStart(2, '0')}`;
}
